// Ensure we only initialize the observers once per page
  if (!window.globalImageRevealInitialized) {
    window.globalImageRevealInitialized = true;
    
    function initGlobalImageReveal() {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          // Trigger ONLY when the image actually enters the screen
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: "50px 0px", // Triggers just before the image enters the screen
        threshold: 0.01 
      });

      // Function to find and observe un-animated images
      function scanForImages() {
        const images = document.querySelectorAll('img:not(.is-visible):not(.icon):not(.header__icon img)');
        images.forEach(img => {
          // If the image is ALREADY on the screen on load (like a top banner), animate it immediately
          if (img.getBoundingClientRect().top < window.innerHeight) {
            img.classList.add('is-visible');
          } else {
            // Otherwise, wait for the scroll
            imageObserver.observe(img);
          }
        });
      }

      scanForImages(); // Run the initial scan

      // CRITICAL FIX FOR RELATED PRODUCTS: 
      // Watch for new images dynamically injected by Shopify (e.g., AJAX lazy-loads)
      const mutationObserver = new MutationObserver((mutations) => {
        let hasNewElements = false;
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length > 0) hasNewElements = true;
        });
        if (hasNewElements) {
          scanForImages(); // Rescan when new HTML is added to the page
        }
      });
      mutationObserver.observe(document.body, { childList: true, subtree: true });

      // 🚨 FIXED FAILSAFE 🚨
      // If the top banner gets stuck due to a theme conflict, force it to show after 1.5s.
      setTimeout(() => {
        document.querySelectorAll('img:not(.is-visible):not(.icon):not(.header__icon img)').forEach(img => {
          if (img.getBoundingClientRect().top < window.innerHeight) {
            img.classList.add('is-visible');
          }
        });
      }, 1500);
    }

    // Run on all possible load events to catch everything (initial load, lazy load, section refresh)
    document.addEventListener('DOMContentLoaded', initGlobalImageReveal);
    window.addEventListener('load', initGlobalImageReveal);
    document.addEventListener('shopify:section:load', () => setTimeout(initGlobalImageReveal, 100));
    
    // Fallback in case the script loads after DOMContentLoaded
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initGlobalImageReveal();
    }
  }